/**
 * @fileoverview Standard HTTP Headers for API Endpoints
 * @description Required headers for all API responses
 * @version 0.18.4
 */

/**
 * Standard headers that must be included in all API responses
 */
export const STANDARD_HEADERS = {
  'X-Contracts-Version': '0.18.4',
  'Content-Type': 'application/json',
} as const;
